import { ellipsis } from "polished";
import styled from "styled-components";

import { T_PLAIN_small, T_TITLE_4_NORMAL } from "../../../global.style";
import { VIEW_PADDING_VALUE } from "../../../views/View.styles";

export const TaxpayerDeclarationOverviewTableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 13px;
    
    table {
        ${T_PLAIN_small};
        border-collapse: collapse; 
        thead tr {
            border-bottom: 1px solid ${props => props.theme.C_BTN_4L_trans_line_color_hover};
        }
        td, th {
            padding: 7px 0;
        }
        th:first-child {
            text-align: left;
        }
        td:not(:first-child), th:not(:first-child) {
            padding-left: 42px;
            text-align: right;
        }
    }
`;

export const TaxpayerDeclarationOverviewTitle = styled.div`
    ${T_TITLE_4_NORMAL};
`;

export const OtherEmploymentAmountsGrid = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
    gap: 15px;
    margin-left: -12px;
    padding-right: 12px;
    
    div:nth-child(2n) {
        margin-right: 0;
    }
`;

export const MonthsSelectorWithSwitchWrapper = styled.div`
    display: flex;
    min-height: 52px; // to make it not jump when switching between months and switch
    align-items: flex-end;
    white-space: nowrap;
    & > div:first-child {
        margin-right: 0px;
    }
`;

export const CheckGroupWrap = styled.div`
    display: flex;
    align-items: flex-end;
    padding-bottom: 6px;
`;

export const FileNameWrapper = styled.div`
    position: absolute;
    top: 10px;
    left: ${VIEW_PADDING_VALUE}px;
    max-width: 80%;
    ${ellipsis()};
`;
